import { ISuiteTypes } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions, Not, Null } from '@llws/dynamic-router-utils';
import { IStateStrict } from '@/shared/interfaces/store-base';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/units';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'suiteTypeModel',
      alias: 'suiteTypeModel',
    },
  ],
  where: [
    Not(Null('suiteTypeModelId')),
    Not(Equal('status', 'deleted')),
  ],
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'suiteTypeCommercialFields',
      alias: 'stcf',
    },
    {
      path: 'suiteTypesFloorplans',
      alias: 'stf',
    },
    {
      path: 'suitesHasPhotos',
      alias: 'shp',
    },
    {
      path: 'shp.listingPhoto',
      alias: 'shplp',
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ISuiteTypes>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'units/'

  state: {
    ...base.state,
    ...{
      modelId: 0,
    },
  },

  getters: {
    ...base.getters,
    ...{

      // Override the getter 'list' from the base implementation
      list(state: IStateStrict<ISuiteTypes>) {
        if (state.list?.data) {
          const list = state.list.data.map((l: ISuiteTypes) => ({
            ...l,
            ...{
              suitesHasPhotos: l.suitesHasPhotos!
                .filter((v) => v.listingPhoto?.active === 1 && v.listingPhoto?.buildingId === l.buildingId)
                .sort((a, b) => (a.orderBy > b.orderBy ? 1 : -1)),
            },
          }));

          return (state as any).modelId
            ? list.filter((v: ISuiteTypes) => v.suiteTypeModelId === (state as any).modelId)
            : list;
        }

        return [];
      },

      // Override the getter 'single' from the base implementation
      single(state: IStateStrict<ISuiteTypes>) {
        if (state.single && state.single.hasOwnProperty('suitesHasPhotos')) {
          return {
            ...state.single.data!,
            ...{
              suitesHasPhotos: state.single.data?.suitesHasPhotos!
                .filter((v) => v.listingPhoto?.active === 1 && v.listingPhoto?.buildingId === state.single?.data?.buildingId)
                .sort((a, b) => (a.orderBy > b.orderBy ? 1 : -1)),
              suiteTypesFloorplans: state.single.data?.suiteTypesFloorplans!
                .sort((a, b) => (a.orderBy > b.orderBy ? 1 : -1)),
            },
          } as ISuiteTypes;
        }

        return undefined;
      },
    },
  },

  mutations: {
    ...base.mutations,

    ...{
      setModelId(state: any, payload: number) {
        state.modelId = payload;
      },
    },
  },

  actions: {
    ...base.actions,
  },
};
